import { cn } from "@/lib/utils"

/**
 * Base Skeleton Component
 *
 * Displays an animated loading placeholder.
 */
function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-slate-200", className)}
      {...props}
    />
  )
}

export { Skeleton }
